import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rec-skeleton" };
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'SkeletonLoader',
    props: {
        height: { default: "1em" },
        width: { default: "auto" },
        borderRadius: { default: "0.25rem" }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "00808b4e": (_ctx.height),
            "f617d358": (_ctx.width),
            "0c26f790": (_ctx.borderRadius)
        }));
        // Types & Enums
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
